import React,{useState, useEffect} from 'react'
import {createOrderAction} from "../../store/order/actions"
import { useSelector,useDispatch } from "react-redux";
import {loginAction} from "../../store/auth/actions"
import {login,reset} from '../../store/auth/authSlice'
import {toast} from 'react-toastify'

import Layout from "../layout/Layout"
import { useNavigate } from "react-router-dom";


const Login = () => {
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");
    const navigate = useNavigate()
    const dispatch = useDispatch<any>()

    const {user, isLoading, isError, isSuccess, message} = useSelector(
        (state:any) => state.auth)

    useEffect(() => {
        if(isError) {
            toast.error(message)
        }
        if(isSuccess || user){
            navigate('/')
        }
        
        dispatch(reset())

    },[user,isError,isSuccess,message,navigate,dispatch])





//     const { auth } = useSelector((state: any) => state);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [fullName,setFullName] = useState("");
    // const [email,setEmail] = useState("");
    // const [password,setPassword] = useState("");

//     const [address,setAddress] = useState("");
//     const [phoneNumber,setPhoneNumber] = useState("");

// //    useEffect(() => {
// //     if(auth?.token){
// //         setFullName(auth?.user?.names);
// //         setEmail(auth?.user?.email);
// //         setAddress(auth?.user?.address);
// //         setPhoneNumber(auth?.user?.phone);


 
// //     }

// //    },[auth?.token])

   const handleLogin = async() => {
      

    // await loginAction({email,password})(dispatch);
    
    // navigate("/");
    if(!password || !email) {
        toast.error('Please fill in all the fields')
    }else{
        const userData = {
            email,
            password
        }
        dispatch(login(userData))
    }
    console.log('changed');

   }
  

  return (
    <Layout>
  
    <div className="cart-table-area section-padding-100">
    <div className="container-fluid">
        <div className="row">
            <div className="col-12 col-lg-8">
                <div className="checkout_details_area mt-50 clearfix">

                    <div className="cart-title">
                        <h2>Login</h2>
                    </div>

                    <form action="#" method="post">
                        <div className="row">
                            
                            <div className="col-12 mb-3">
                            <p><label>Email</label></p>

                                <input type="email" className="form-control" id="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                            </div>
                            <div className="col-12 mb-3">
                            <p><label>Password</label></p>

                                <input type="password" className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                            </div>

                            <div className="cart-btn mt-100 col-12 mb-3">
                                <a href="#" className="btn amado-btn w-100" onClick={handleLogin}>Login</a>
                            </div>
                            
                        </div>
                    </form>
                </div>
            </div>
            
        </div>
    </div>
</div>



    
    
    </Layout>
  )
}

export default Login